import http from './http-common';
class ProductService {
  getProduct(productId: string) {
    return http.get(`product/${productId}`);
  }

  getAllProduct() {
    return http.get<any>('product/');
  }

  updateProduct(productId: any, data: any) {
    return http.post(`product/update/${productId}`, data);
  }

  createProduct(data: any) {
    return http.post('product/', data);
  }

  removeProduct(productId: any) {
    return http.get(`product/delete/${productId}`);
  }

  removeProductMedia(productId: any, mediaId: any) {
    return http.get(`product/media/delete/${productId}/${mediaId}`);
  }
}
export default new ProductService();
